import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { NgForm } from "@angular/forms";
import { User } from "./user.service";
import { Company } from "./company.service";
import { SERVER, LOGON_INFO } from "../app.constants";
import { CommonService } from "../app.service";


@Injectable()
export class MemberRegisterService {

    constructor(
        private _htc: HttpClient,
        private commonService: CommonService
    ) { }

    //会員新規登録
    registMember(member: Member): Observable<Company> {
        let logon_id = LOGON_INFO.USER_ID;
        if (logon_id) {
            member.company.create_id = logon_id;
            member.company.update_id = logon_id;
            member.user.create_id = logon_id;
            member.user.update_id = logon_id;
        }

        member.company.address_lat = this.commonService.decimalRound(member.company.address_lat, 6);
        member.company.address_lng = this.commonService.decimalRound(member.company.address_lng, 6);

        return this._htc.post<Company>(SERVER.baseURL+'/member-regist/', JSON.stringify(member));
    }
}



export class Member {
    
    company: Company;
    user: User;
    
    constructor(company, user) {
        this.company = company;
        this.user = user;
    }

}



// WEBPACK FOOTER //
// ./src/app/member-kanri/member-register.service.ts